import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="documents--item-description"
// Manages description row visibility and content
export default class extends Controller {
  static outlets = ["documents--item"]

  static targets = ["description"]

  connect() {
    // Description row visibility is handled by server-side rendering
    // (hidden if description is empty, shown if it has content)
  }

  // Hide description row and clear content (called from delete button)
  hide() {
    if (this.hasDescriptionTarget) {
      this.descriptionTarget.value = ""
    }
    this.element.classList.add("d-none")
  }

  // Show description row (called from invoice-item controller)
  show() {
    // Clear description when showing (to start fresh)
    if (this.hasDescriptionTarget) {
      this.descriptionTarget.value = ""
    }
    this.element.classList.remove("d-none")
    // Focus on description field
    if (this.hasDescriptionTarget) {
      this.descriptionTarget.focus()
    }
  }
}
